import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none">
      <polygon fill="#C4373A" points="0 31.806 32 31.806 32 .776 0 .776"/>
      <path fill="#FFF"
            d="M13.4484,5.72033939 L4.4615,9.58070303 L13.4484,13.4625939 L13.4484,5.72033939 Z M2.1437,10.4506182 L0.0496,9.58671515 L2.1437,8.65551515 L19.8926,0.915006061 L19.8926,2.97677576 L15.2389,4.96610909 L15.2389,14.2169212 L19.8926,16.2277818 L19.8926,18.1954909 L2.1437,10.4506182 Z"
            transform="translate(6 6.788)"/>
    </g>
  </svg>
);
